export const PUBLISH_SURVEY_SUCCESS = "Survey published successfully";
export const SCHEDULE_SURVEY_SUCCESS = "Survey scheduled successfully";
export const RENAME_PROJECT_SUCCESS = "Project renamed successfully";
